import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { ControlContainer as ControlContainer$1 } from '../../../ControlContainer/ControlContainer.js';
import { useFormFieldContext } from '../../hooks/useFormFieldContext.js';

var _excluded = ["children", "size"];
var ControlContainer = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useFormFieldContext = useFormFieldContext(),
    isDisabled = _useFormFieldContext.isDisabled,
    isReadOnly = _useFormFieldContext.isReadOnly,
    state = _useFormFieldContext.state;
  return /*#__PURE__*/React.createElement(ControlContainer$1, _extends({
    ref: ref,
    size: size,
    state: state,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly
  }, props), children);
}));
ControlContainer.displayName = 'FormField.ControlContainer';

export { ControlContainer };
//# sourceMappingURL=ControlContainer.js.map
